<template>
  <main class="tariffs">
    <div class="tariffs__container">
      <div class="tariffs__row tariffs__header">
        <h1 class="tariffs__title">Тарифы</h1>
        <div class="tariffs__info-actions">
          <div
            class="tariffs__info"
            v-if="tariffInfo"
            v-html="tariffInfo"
          />
          <button
            v-if="canTariffPayment"
            class="tariffs__button"
            type="button"
            v-bind:disabled="isBillingInvoiceAwaitRequest"
            v-on:click="onShowBillingInvoiceForm"
          >
            Продлить тариф
          </button>
        </div>
      </div>
      <div class="tariffs__group">
        <button
          class="tariffs__details"
          v-bind:class="{ active: specificationBlock }"
          v-on:click="specificationBlock = !specificationBlock"
          type="button"
        >
          Нет скрытых платежей. Весь функционал входит в тариф
        </button>
        <ul v-if="specificationBlock">
          <li>Расписание клиники</li>
          <li>База пациентов</li>
          <li>Лист ожидания</li>
          <li>Электронная медицинская карта</li>
          <li>Интерактивная зубная формула</li>
          <li>Шаблоны документов для пациента</li>
          <li>Шаблоны протоколов приема</li>
          <li>Планы лечения</li>
          <li>Задачи</li>
          <li>Отчеты</li>
        </ul>
      </div>
      <div class="tariffs__table-basic">
        <div class="tariffs__table-basic__header">
          <div class="tariffs__table-basic__row">
            <div>Количество кресел</div>
            <div>1</div>
            <div>2</div>
            <div>3</div>
            <div>4</div>
            <div>5+</div>
          </div>
        </div>
        <div class="tariffs__table-basic__body">
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 3 мес. (Цена без скидки)</div>
            <div class="tariffs__table-basic__cell tariff-cell">90 000 ₸</div>
            <div class="tariffs__table-basic__cell tariff-cell">107 100 ₸</div>
            <div class="tariffs__table-basic__cell tariff-cell">123 200 ₸</div>
            <div class="tariffs__table-basic__cell tariff-cell">134 400 ₸</div>
            <div class="tariffs__table-basic__cell tariff-cell">151 900 ₸</div>
          </div>
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 6 мес. (Скидка 10%)</div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>162 000 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>192 800 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>221 700 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>241 800 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>273 400 ₸</span>
            </div>
          </div>
          <div class="tariffs__table-basic__row">
            <div class="tariffs__table-basic__cell">на 12 мес. (Скидка 20%)</div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>288 100 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>342 700 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>394 100 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>429 900 ₸</span>
            </div>
            <div class="tariffs__table-basic__cell tariff-cell">
              <span>486 000 ₸</span>
            </div>
          </div>
        </div>
      </div>
      <section v-if='false' class="tariffs__section">
        <h2 class="tariffs__caption">Дополнительные модули</h2>
        <button
          class="tariffs__details"
          v-bind:class="{ active: cashboxBlock }"
          v-on:click="cashboxBlock = !cashboxBlock"
          type="button"
        >
          Онлайн-касса
        </button>
        <div v-if="cashboxBlock" class="tariffs__table-cashbox">
          <div class="tariffs__table-cashbox__header">
            <div>Срок доступа</div>
            <div>3 месяца</div>
            <div>6 месяцев</div>
            <div>12 месяцев</div>
          </div>
          <div class="tariffs__table-cashbox__body">
            <div>Стоимость</div>
            <div data-label="3 месяца">
              1 300&#8381;/мес.<br>
              <span>3 900&#8381;/3 мес.</span>
            </div>
            <div data-label="6 месяцев">
              1 150&#8381;/мес.<br>
              <span>6 900&#8381;/6 мес.</span>
            </div>
            <div data-label="12 месяцев">
              920&#8381;/мес.<br>
              <span>11 040&#8381;/12 мес.</span>
            </div>
          </div>
        </div>
        <button
          class="tariffs__details"
          v-bind:class="{ active: smsBlock }"
          v-on:click="smsBlock = !smsBlock"
          type="button"
        >
          Модуль &#171;Sms-рассылки&#187;
        </button>
        <div v-if="smsBlock">
          <div class="tariffs__description">
            Напоминайте вашим клиентам о предстоящем приёме, информируйте об акциях,
            поздравляйте с праздниками.<br><br>
            Чтобы отправлять sms от имени вашей клиники, необходимо зарегистрировать
            имя отправителя.
            <br>
            У операторов Мегафон и МТС это платная услуга.
          </div>
          <h3 class="tariffs__text">
            Стоимость SMS
          </h3>
          <div class="tariffs__units">
            <tariff-appointment
              v-for="(tariff, key) in smsMailings.tariffs"
              v-bind:key="key"
              v-bind:caption="tariff.caption"
              v-bind:price="tariff.price"
              bold-caption
            />
          </div>
        </div>
        <button
          class="tariffs__details"
          v-bind:class="{ active: uisBlock }"
          v-on:click="uisBlock = !uisBlock"
          type="button"
        >
          Телефония
        </button>
        <div v-if="uisBlock">
          <div class="tariffs__units">
            <div class="tariffs__unit">
              <p class="tariffs__unit__price">По тарифам оператора</p>
            </div>
          </div>
        </div>
        <button
          class="tariffs__details"
          v-bind:class="{ active: egisBlock }"
          v-on:click="egisBlock = !egisBlock"
          type="button"
        >
          ЕГИСЗ
        </button>
        <div v-if="egisBlock">
          <div class="tariffs__description">
            <a
              href="https://mis-help.32top.kz/instructions/start_work/egisz"
              target="_blank"
              rel="noopener noreferrer">
              Как подключить клинику к ЕГИСЗ
            </a>
          </div>
          <div class="tariffs__units column">
            <div class="tariffs__unit">
              <p class="tariffs__unit__caption">
                Первые 99 протоколов
              </p>
              <p class="tariffs__unit__price">
                Бесплатно
              </p>
            </div>
            <div class="tariffs__unit">
              <p class="tariffs__unit__caption">
                100+ протоколов
              </p>
              <p class="tariffs__unit__price">
                500 тенге/мес*
              </p>
            </div>
            <p>* Списание денег осуществляется с личного кабинета Медфлекс</p>
          </div>
        </div>
        <button
          class="tariffs__details"
          v-bind:class="{ active: whatsBlock }"
          v-on:click="whatsBlock = !whatsBlock"
          type="button"
        >
          WhatsApp
        </button>
        <div v-if="whatsBlock">
          <div class="tariffs__units">
            <div class="tariffs__unit">
              <p class="tariffs__unit__price">1000&#8381;/мес </p>
            </div>
          </div>
        </div>
      </section>
      <section class="tariffs__section">
        <h2 class="tariffs__caption">Реферальная программа</h2>
        <section class="tariffs__referrall-program">
          <h3 class="tariffs__subtitle">Бонус на ваш выбор</h3>
          <div class="bonus-table">
            <div class="bonus-table__row">
              <div class="bonus-table__cell">
                Продажа МИС 32top на 3 месяца по вашей рекомендации
              </div>
              <div class="bonus-table__cell bonus-table__value">
                <p class="bonus-table__col">
                  <strong>26 000 ₸</strong>
                  <span>на карту</span>
                </p>
                <p class="bonus-table__col">или</p>
                <p class="bonus-table__col">
                  <strong>3 месяца</strong>
                  <span>в подарок<sup>**</sup></span>
                </p>
              </div>
            </div>
            <div class="bonus-table__row">
              <div class="bonus-table__cell">
                Продажа МИС 32top на 6 месяцев по вашей рекомендации
              </div>
              <div class="bonus-table__cell bonus-table__value">
                <p class="bonus-table__col">
                  <strong>65 000 ₸</strong>
                  <span>на карту</span>
                </p>
                <p class="bonus-table__col">или</p>
                <p class="bonus-table__col">
                  <strong>6 месяцев</strong>
                  <span>в подарок<sup>**</sup></span>
                </p>
              </div>
            </div>
            <div class="bonus-table__row">
              <div class="bonus-table__cell">
                Новый лид<sup>*</sup>, который не совершил покупку программы
              </div>
              <div class="bonus-table__cell bonus-table__value">
                <p class="bonus-table__col">
                  <strong>13 000 ₸</strong>
                  <span>на карту</span>
                </p>
              </div>
            </div>
            <div class="bonus-table__footer">
              <p class="bonus-table__text">
                <sup>*</sup> Лид — это заинтересованный клиент, который
                зарегистрировался на&nbsp;демо период. Бонус за&nbsp;лид
                будет начислен в&nbsp;течение 14&nbsp;дней после регистрации
                клиента в&nbsp;программе.
              </p>
              <p class="bonus-table__text">
                <sup>**</sup> Бесплатное продление тарифа
                доступно только пользователям МИС 32top.
              </p>
            </div>
          </div>
        </section>
      </section>
      <support-contacts
        title="Для подключения услуги свяжитесь с нами удобным способом"
        class="tariffs__support"
        v-bind:phone-title="this.$options.managerPhoneTitle"
        v-bind:phone-href="this.$options.managerPhoneHref"
      >
        <modal-dialog
          max-width="90%"
          v-bind:title="orderConsultationTitle"
          v-model="isShowOrderConsultationForm"
          width="400px"
          with-cross
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="tariffs__support__btn"
              type="button"
              v-on="listenerObject"
            >Заказать консультацию</button>
          </template>
          <div
            class="tariffs__modal__content"
            v-if="isOrderSended"
          >
            <span class="tariffs__modal__caption">{{ orderConsultationMessage }}</span>
          </div>
          <form
            class="tariffs__modal__content"
            v-else
            v-on:submit.prevent="onSubmitOrderConsultation"
          >
            <input-text
              placeholder="Введите ФИО"
              title="ФИО"
              v-bind:violations="orderConsultationFullNameViolations"
              v-letter-capital
              v-model="orderConsultationFullName"
            />
            <input-phone
              v-model="orderConsultationPhone"
              v-bind:violations="orderConsultationPhoneViolations"
            />
            <button
              class="tariffs__modal__btn"
              type="submit"
              v-bind:disabled="disableOrderConsultationButton"
            >Заказать</button>
          </form>
        </modal-dialog>
      </support-contacts>
    </div>
    <side-slide-transition>
      <side-dialog
        v-if="isShowBillingInvoiceForm"
        v-click-outside="closeBillingInvoiceDialogForm"
        v-on:cancel="closeBillingInvoiceDialogForm"
        label="Продлить тариф">
        <form-billing-invoice
          v-bind:is-await-request="isBillingInvoiceAwaitRequest"
          v-bind:module-options="billingInvoiceModules"
          v-bind:packet-module-options="billingInvoicePacketModules"
          v-bind:preselected-modules="selectedBillingInvoiceModules"
          v-bind:preselected-tariffs="selectedBillingInvoiceTariffs"
          v-bind:tariff-options="billingInvoiceTariffs"
          v-on:download="onDownloadBillingInvoice"
        />
      </side-dialog>
    </side-slide-transition>
  </main>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';
import FormBillingInvoice from '@/components/FormBillingInvoice.vue';
import SupportContacts from '@/components/SupportContacts.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import InputPhone from '@/components/InputPhone.vue';
import InputText from '@/components/InputText.vue';
import notifierMixin from '@/mixins/notifierMixin';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import SideDialog from '@/components/SideDialog.vue';
import saveFileMixin from '@/mixins/saveFileMixin';
import billingInvoiceMixin from '@/mixins/billingInvoiceMixin';
import { OrderConsultationRequest } from '@/storage/gateways/TariffGateway';
import supportContactsMixin from '@/mixins/supportContactsMixin';

const TariffAppointment = {
  functional: true,
  name: 'TariffAppointment',
  props: {
    price: {
      type: Number,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
    boldCaption: {
      type: Boolean,
      default: () => false,
    },
    priceCurrency: {
      type: String,
      default: () => '₸',
    },
  },
  render(createElement, { props }) {
    const subtitleElement = createElement(
      'p',
      { class: props.boldCaption ? 'tariffs__unit__caption' : 'tariffs__unit__subtitle' },
      props.caption,
    );
    const priceElement = createElement(
      'p',
      { class: 'tariffs__unit__price' },
      `${props.price} ${props.priceCurrency}`,
    );
    return createElement(
      'article',
      { class: 'tariffs__unit' },
      [subtitleElement, priceElement],
    );
  },
};

/**
 * @description Время показа уведомления об успешно отправленной заявке.
 * @type {number}
 */
const SHOW_SUCCESS_NOTIFICATION_TIMEOUT = 3000;

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.orderConsultationViolations ? vm.orderConsultationViolations[cause] : []
);

/**
 * @description Примесь заказа консультации.
 * @type {Vue}
 */
const orderConsultationMixin = {
  computed: {
    /**
     * @description Деактивировать кнопку отправки.
     * @type {boolean}
     */
    disableOrderConsultationButton() {
      return this.isOrderConsultationAwaitRequest;
    },
    orderConsultationFullNameViolations: resolveInputErrors('full-name'),
    orderConsultationPhoneViolations: resolveInputErrors('phone'),
    /**
     * @description Заголовок диалога заказа консультации.
     * @type {string}
     */
    orderConsultationTitle() {
      if (this.isOrderSended) {
        return '';
      }
      return 'Заполните данные, и наш менеджер свяжется с вами в ближайшее время';
    },
  },
  data() {
    return {
      /**
       * @description Ожидание завершения запроса.
       * @type {boolean}
       */
      isOrderConsultationAwaitRequest: false,
      /**
       * @description Показывать форму.
       * @type {boolean}
       */
      isShowOrderConsultationForm: false,
      /**
       * @description ФИО.
       * @type {string}
       */
      orderConsultationFullName: '',
      /**
       * @description Сообщение о заявке на консультацию.
       * @type {string}
       */
      orderConsultationMessage: '',
      /**
       * @description Телефон.
       * @type {string}
       */
      orderConsultationPhone: '',
      /**
       * @description Нарушения ограничений.
       * @type {any}
       */
      orderConsultationViolations: {},
      /**
       * @description Заявка отправлена.
       * @type {boolean}
       */
      isOrderSended: false,
    };
  },
  methods: {
    /**
     * @description Обработать заказ консультации.
     * @returns {void}
     */
    onSubmitOrderConsultation() {
      const request = new OrderConsultationRequest(
        this.orderConsultationFullName,
        this.orderConsultationPhone,
      );
      this.isOrderConsultationAwaitRequest = true;
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
        this.orderConsultationViolations = error.allCauses();
      };
      const onSuccess = (message) => {
        this.notifySuccess(message);
        this.orderConsultationFullName = '';
        this.orderConsultationMessage = message;
        this.orderConsultationPhone = '';
        this.orderConsultationViolations = {};
        this.isOrderSended = true;
        setTimeout(
          () => { this.isShowOrderConsultationForm = false; },
          SHOW_SUCCESS_NOTIFICATION_TIMEOUT,
        );
      };
      this
        .$tariffGateway
        .orderConsultation(request)
        .then((result) => result.fold(onFail, onSuccess))
        .finally(() => { this.isOrderConsultationAwaitRequest = false; });
    },
  },
};

const clinicTariffInfoMixin = {
  computed: {
    canTariffPayment() {
      return this.tariffActions.includes('tariff-payment');
    },
  },
  created() {
    this.fetchTariffInfo();
  },
  data() {
    return {
      /**
       * @description Действия над тарифом.
       * @param {string[]}
       */
      tariffActions: [],
      /**
       * @description Текст с информацией о тарифе
       * @type {null|String}
       */
      tariffInfo: null,
    };
  },
  methods: {
    /**
     * @description Получить информацию о тарифе
     */
    fetchTariffInfo() {
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      const onSuccess = (response) => {
        this.tariffInfo = response.tariffInfo;
        this.tariffActions = response.actions;
      };
      this
        .$tariffGateway
        .getTariffInfo()
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Выбрать опции по умолчанию.
     * @returns {void}
     */
    preselectDefaultBillingOptions() {
      this.selectedBillingInvoiceTariffs = this
        .billingInvoiceTariffs
        .filter((candidate) => candidate.is_preselected)
        .slice(0, 1)
        .map((tariff) => ({
          prices: tariff.prices,
          selectedPrice: tariff.prices[0],
          selectedTariff: tariff,
        }));
      this.selectedBillingInvoiceModules = this
        .billingInvoiceModules
        .filter((candidate) => candidate.is_preselected)
        .map((module) => ({
          prices: module.prices,
          selectedPrice: module.prices[0],
          selectedTariff: module,
        }));
    },
  },
};

export default {
  name: 'ClinicPanelTariffs',
  components: {
    FormBillingInvoice,
    InputPhone,
    InputText,
    ModalDialog,
    SideDialog,
    SideSlideTransition,
    SupportContacts,
    TariffAppointment,
  },
  data() {
    return {
      specificationBlock: false,
      cashboxBlock: false,
      smsBlock: false,
      uisBlock: false,
      egisBlock: false,
      whatsBlock: false,
      /**
       * Список тарифов на рассылки смс
       */
      smsMailings: {
        tariffs: [
          { price: 7, caption: '1 SMS' },
        ],
      },
    };
  },
  methods: {
    showDialogTariffsByRoute() {
      if (this.$route.query.tariff) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.onShowBillingInvoiceForm();
          }, 300);
        });
      }
    },
  },
  watch: {
    $route: {
      handler: 'showDialogTariffsByRoute',
      immediate: true,
    },
  },
  mixins: [
    aboutMixin,
    billingInvoiceMixin,
    clinicTariffInfoMixin,
    notifierMixin,
    orderConsultationMixin,
    saveFileMixin,
    supportContactsMixin,
  ],
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.text__violation {
  margin-bottom: 0 !important;
}
.tariffs {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  &__container {
    width: min(100%,1220px);
    padding: 38px 20px 200px 23px;
  }
  &__row {
    display: flex;
    flex-flow: row wrap;
    gap: 20px;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 40px 0;
  }
  &__info-actions {
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
  }
  &__info {
    border: 1px solid #C2CFE0;
    background: transparent;
    border-radius: 4px;
    padding: 10px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    color: #000000;
    font-family: 'Lato', sans-serif;
    span {
      color: #EF474C;
    }
  }
  &__button {
    @include buttons.btn-blue(100%, 42px, 16px);
    max-width: 160px;
  }
  &__group {
    ul {
      margin: 0 0 30px 0;
    }
  }
  &__table-basic {
    display: flex;
    flex-direction: column;
    border: 1px solid #C2CFE0;
    margin: 0 0 50px 0;
    overflow: auto;
    &__header {
      min-width: 995px;
      font-weight: 600;
      font-size: 20px;
      line-height: 29px;
      .tariffs__table-basic__row {
        &:last-child {
          border-top: 1px solid #C2CFE0;
        }
      }
    }
    &__body {
      min-width: 995px;
      .tariffs__table-basic__row {
        border-top: 1px solid #C2CFE0;
      }
    }
    &__row {
      display: grid;
      grid-template-columns: 1.8fr repeat(5, 1fr);
      text-align: center;
      div {
        border-right: 1px solid #C2CFE0;
        padding: 10px;
      }
      div:first-child {
        text-align: left;
        color: black;
      }
      div:last-child {
        border-right: none;
      }
    }
    &__cell {
      display: grid;
      align-items: center;
      gap: 5px;
      &.tariff-cell {
        color: #0489E0;
        p {
          display: block;
        }
      }
      .tariff-cell {
        &__saving-money {
          font-size: 14px;
          color: #546C85;
          span {
            white-space: nowrap;
          }
        }
      }
    }
  }
  &__table-cashbox {
    margin: 0 0 30px 0;
    max-width: 870px;
    width: 100%;
    &__header,
    &__body {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      div {
        padding: 10px;
      }

    }
    &__header {
      border-bottom: 2px solid #0489E0;
      div {
        font-weight: 600;
      }
    }
    &__body {
      div:first-child {
        font-weight: 600;
      }
      div span {
        color: #90A0B7;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
      }
    }
  }
  &__section {
    margin-bottom: 50px;
  }
  &__caption {
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    margin: 0 0 20px 0;
  }
  &__subtitle {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
    line-height: normal;
  }
  &__details {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    margin: 0 0 20px 0;
    max-width: 550px;
    width: 100%;
    text-align: left;
    &:after {
      content: '';
      background-image: url("@/assets/img/checked/arrow-top-blue.svg");
      background-repeat: no-repeat;
      background-position: center;
      width: 30px;
      height: 30px;
      margin: 0 0 0 20px;
    }
    &.active:after {
      transform: rotate(180deg);
    }
  }
  &__text {
    font-weight: 600;
    font-size: 18px;
    line-height: 29px;
    margin: 0 0 20px 0;
  }
  &__units {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 33px;
    margin: 0 0 64px 0;
    &.column {
      flex-direction: column;
      gap: 15px;
    }
  }
  &__unit {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    border: 1px solid #C2CFE0;
    border-radius: 6px;
    gap: 10px;
    width: fit-content;
    p {
      margin: 0;
    }
    &__caption {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
    }
    &__price {
      font-weight: 400;
      font-size: 32px;
      line-height: 38px;
      color: #0489E0;
      span {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
  &__description {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #323C47;
    margin: 0 0 33px 0;
    a:hover {
      text-decoration: none;
    }
  }
  &__support {
    margin: 60px 0 0 0;
    .support-contacts__right {
      gap: 10px;
    }
    &__btn {
      @include buttons.btn-blue(100%, 56px, 22px);
      border-radius: 6px;
      max-width: 333px;
    }
  }
  &__modal {
    &__caption {
      font-size: 1.25rem;
      font-weight: 500;
      color: var(--reading-color);
      letter-spacing: .0125em;
      text-align: center;
    }
    &__content {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    &__btn {
      margin: 30px auto 0;
      @include buttons.btn-blue(100%, 48px, 16px);
      background-color: #0489E0 !important;
      color: #FFFFFF !important;
      height: 46px !important;
    }
  }
}

.bonus-table {
  display: grid;
  row-gap: 15px;
  max-width: 900px;
  &__row {
    display: grid;
    grid-template-columns: minmax(150px, 380px) 280px;
    align-items: center;
    gap: 5px 20px;
  }
  &__value {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & &__col {
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 0;
    font-weight: 600;
    color: var(--action-color);
    strong {
      font-size: 18px;
    }
    span {
      color: #546C85;
    }
  }
  & &__text {
    display: block;
    margin-block: 10px;
  }
  sup {
    top: -0.2em;
    font-size: inherit;
    color: var(--action-color);
  }
}

.tariffs-form {
  display: grid;
  row-gap: 28px;
  & &__title {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    color: var(--reading-color);
  }
  &__header {
    display: flex;
    flex-direction: column;
    row-gap: 25px;
  }
  &__section {
    position: relative;
    padding-bottom: 30px;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: -27px;
      right: -27px;
      height: 1px;
      background-color: var(--border-color);
    }
  }
  &__payment-modes {
    display: flex;
    flex-direction: row;
  }
  &__payment-mode {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 .8125rem;
    height: 2.5rem;
    width: min(100%, 144px);
    background: var(--fill-color);
    color: var(--reading-color);
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.065rem;
    cursor: pointer;
    &:first-of-type {
      border-bottom-left-radius: var(--input-border-radius);
      border-top-left-radius: var(--input-border-radius);
    }
    &:last-of-type {
      border-bottom-right-radius: var(--input-border-radius);
      border-top-right-radius: var(--input-border-radius);
    }
    &.selected {
      background: var(--action-color);
      color: var(--primary-background-color);
    }
  }
  &__price {
    font-size: 22px;
    color: var(--action-color);
    &.discount {
      font-weight: 500;
      font-size: 16px;
      color: var(--placeholder-color);
      position: relative;
      &::before {
        content: "";
        width: 100%;
        height: 95%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(
          to top right,
          transparent calc(50% - 1px),
          var(--placeholder-color),
          transparent calc(50% + 1px)
        );
      }
    }
  }
  &__button-submit {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 160px;
    &.disabled {
      background-color: var(--unfocus-color);
    }
  }
  &__footer {
    display: grid;
    justify-content: end;
    justify-items: end;
    row-gap: 34px;
    margin-top: 67px;

  }
  &__total {
    display: flex;
    align-items: center;
    column-gap: 15px;
    & &__title {
      font-size: 22px;
    }
  }
}
@media screen and (max-width: 1360px) {
  .tariffs {
    &__container {
      width: 100%;
      padding: 40px 20px 100px 20px;
    }
  }
}
@media screen and (max-width: 730px) {
  .tariffs {
    &__header {
      align-items: flex-start;
      flex-direction: column;
    }
    &__info-actions {
      justify-content: flex-start;
      width: 100%;
    }
    &__table-cashbox {
      &__header {
        display: none;
      }
      &__body {
        grid-template-columns: 1fr;
        grid-gap: 10px;
        margin: 0 0 20px 0;
        div {
          display: flex;
          justify-content: space-between;
          text-align: right;
          padding: 0;
          &:first-child {
            display: none;
          }
          &:before {
            content: attr(data-label);
            font-weight: 700;
            margin-right: 20px;
            font-size: 12px;
            line-height: 16px;
          }
        }
      }
    }
  }

}
@media screen and (max-width: 640px) {
  .tariffs {
    &__container {
      padding: 40px 10px 140px;
    }
  }
  .bonus-table {
    &__row {
      grid-template-columns: 1fr;
    }
    &__value {
      max-width: 300px;
    }
  }
}

@media screen and (min-width: 580px) {
  .tariffs {
    &__table-basic {
      &__row {
        div:first-child {
          position: sticky;
          left: 0;
          background-color: #ffffff;
        }
      }
    }
  }
}

</style>
